enum FundAccountPermission {
  READ = 'READ',
  WRITE = 'WRITE',
  UNDEFINED = 'UNDEFINED',
}
export default FundAccountPermission;
